import 'react-native-gesture-handler';
import React, { useEffect } from 'react';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {PersistGate} from 'redux-persist/integration/react';
import {Provider} from 'react-redux';
import useCachedResources from './src/hooks/useCachedResources';
import useColorScheme from './src/hooks/useColorScheme';
import Navigation from './src/navigation';
import store, {persistor} from './src/redux/store';
import 'setimmediate'
import './src/styles/global.css';



export default function App() {
  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();

  if (!isLoadingComplete) {
    return null;
  } else {
    return (
      <Provider store={store}>
        
        <PersistGate loading={null} persistor={persistor}>
          <SafeAreaProvider>
            <Navigation/>
          </SafeAreaProvider>
        </PersistGate>
      </Provider>
    );
  }
}
